import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Location } from '@angular/common';
import { filter } from 'rxjs';
import { sectorModuleRoutes } from './sector-module-view.routing';
import { Breadcrumb } from '../../../shared/components/breadcrumb/breadcrumb';
import { Sidebar } from '../../../shared/components/sidebar/sidebar';

@Component({
  selector: 'app-sector-module-view',
  imports: [Breadcrumb, RouterOutlet, Sidebar],
  templateUrl: './sector-module-view.html',
  styleUrl: './sector-module-view.scss',
})
export class SectorModuleView implements OnInit {
  menuItems = sectorModuleRoutes;
  breadcrumbs: any = [];
  parentRoute: any;

  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly location = inject(Location);

  ngOnInit(): void {
    if (this.route.routeConfig) {
      const { children, ...otherRouteAttributes } = this.route.routeConfig;
      this.parentRoute = otherRouteAttributes;
    }

    this.setAndUpdateBreadCrumbs();
  }

  goBack(): void {
    this.location.back();
  }

  async setAndUpdateBreadCrumbs() {
    this.breadcrumbs = await this.getBreadcrumbs(this.route);
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(async () => {
      this.breadcrumbs = await this.getBreadcrumbs(this.route);
    });
  }

  async getBreadcrumbs(route: ActivatedRoute): Promise<any> {
    const breadcrumbs: any[] = [];
    let currentRoute = route.root;
    let url = '';

    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
      const path = currentRoute.snapshot.url.map((s) => s.path).join('/');
      if (path) url += `/${path}`;
      const label = currentRoute?.routeConfig?.data?.['name'];

      if (label && label != breadcrumbs[breadcrumbs.length - 1]?.label) {
        breadcrumbs.push({ label, url });
      }
    }
    return breadcrumbs;
  }
}
